import React, { useState } from "react";

export default function Script() {
  const [salesModalOpen, setSalesModalOpen] = useState(false);
  const [pricingModalOpen, setPricingModalOpen] = useState(false);

  return (
    <div className="script-page">

      <style>{`
        body {
          margin: 0;
          padding: 40px;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
          background: #f5f5f7;
          color: #1d1d1f;
        }

        .script-page {
          background: #f5f5f7;
          min-height: 100vh;
          padding: 40px 20px;
        }

        .container {
          max-width: 800px;
          margin: auto;
        }

        h1 {
          text-align: center;
          font-size: 28px;
          font-weight: 600;
          margin-bottom: 30px;
          letter-spacing: -0.5px;
        }

        .card {
          background: #ffffff;
          border-radius: 14px;
          padding: 22px 24px;
          margin-bottom: 18px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.06);
        }

        h2 {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 12px;
        }

        p {
          font-size: 14px;
          line-height: 1.7;
          margin: 10px 0;
        }

        .qbox {
          background: #ffcc00;
          color: #000;
          border-radius: 12px;
          padding: 16px 18px;
          margin-top: 12px;
          border: 2px solid #000;
          box-shadow: 0 4px 12px rgba(0,0,0,0.12);
        }

        .qtitle {
          font-weight: 700;
          font-size: 13px;
          margin-bottom: 6px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .btn-col {
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin-top: 4px;
        }

        .objection-btn {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 15px 26px;
          background: #007aff;
          color: #fff;
          border: none;
          border-radius: 12px;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          transition: background 0.18s, transform 0.12s;
          width: 100%;
          box-sizing: border-box;
        }
        .objection-btn:hover { background: #0062cc; transform: translateY(-1px); }
        .objection-btn:active { transform: translateY(0); }

        .pricing-btn {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          padding: 15px 26px;
          background: #007aff;
          color: #fff;
          border: 2px solid #007aff;
          border-radius: 12px;
          font-size: 15px;
          font-weight: 600;
          cursor: pointer;
          transition: background 0.18s, transform 0.12s;
          width: 100%;
          box-sizing: border-box;
        }
        .pricing-btn:hover { background: #0062cc; transform: translateY(-1px); }
        .pricing-btn:active { transform: translateY(0); }

        /* Modal shared */
        .modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.45);
          backdrop-filter: blur(4px);
          z-index: 1000;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 20px;
        }

        .modal {
          background: #fff;
          border-radius: 18px;
          padding: 30px 28px;
          max-width: 560px;
          width: 100%;
          box-shadow: 0 20px 60px rgba(0,0,0,0.2);
          position: relative;
          animation: popIn 0.22s cubic-bezier(0.34,1.56,0.64,1);
        }

        @keyframes popIn {
          from { transform: scale(0.88); opacity: 0; }
          to   { transform: scale(1);    opacity: 1; }
        }

        .modal-close {
          position: absolute;
          top: 14px; right: 16px;
          background: #f2f2f2;
          border: none;
          border-radius: 50%;
          width: 30px; height: 30px;
          font-size: 18px;
          cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          color: #555;
          transition: background 0.15s;
        }
        .modal-close:hover { background: #e0e0e0; }

        .modal-badge {
          display: inline-block;
          background: #007aff;
          color: #fff;
          font-size: 11px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.8px;
          border-radius: 6px;
          padding: 4px 10px;
          margin-bottom: 14px;
        }

        .modal-badge-blue {
          display: inline-block;
          background: #007aff;
          color: #fff;
          font-size: 11px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.8px;
          border-radius: 6px;
          padding: 4px 10px;
          margin-bottom: 14px;
        }

        .modal h3 {
          font-size: 18px;
          font-weight: 700;
          margin-bottom: 10px;
          line-height: 1.3;
        }

        .modal .tagline {
          font-size: 13.5px;
          color: #444;
          margin-bottom: 16px;
          line-height: 1.6;
        }

        .modal-divider {
          text-align: center;
          font-size: 13px;
          font-weight: 700;
          color: #888;
          margin: 12px 0;
          letter-spacing: 1px;
          text-transform: uppercase;
        }

        .modal-list {
          list-style: none;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 8px;
          margin: 14px 0 18px;
          padding: 0;
        }

        .modal-list li {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 13.5px;
          font-weight: 500;
          background: #f0f6ff;
          border-radius: 8px;
          padding: 8px 12px;
        }

        .modal-list li::before {
          content: "✓";
          color: #fff;
          font-weight: 800;
          font-size: 12px;
          background: #007aff;
          width: 20px; height: 20px;
          border-radius: 50%;
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0;
        }

        .modal-footer {
          background: #1d1d1f;
          color: #fff;
          border-radius: 10px;
          padding: 14px 16px;
          font-size: 13.5px;
          line-height: 1.6;
        }

        .modal-footer strong { color: #60aaff; }

        /* Pricing modal specific */
        .pricing-highlight {
          background: #007aff;
          color: #fff;
          border-radius: 12px;
          padding: 18px 20px;
          margin: 14px 0;
          text-align: center;
        }

        .pricing-highlight .price {
          font-size: 32px;
          font-weight: 800;
          letter-spacing: -1px;
        }

        .pricing-highlight .per {
          font-size: 13px;
          opacity: 0.85;
          margin-top: 2px;
        }

        .pricing-footer {
          background: #f5f5f7;
          border-radius: 10px;
          padding: 14px 16px;
          font-size: 13.5px;
          line-height: 1.6;
          color: #333;
          border-left: 4px solid #007aff;
        }
      `}</style>

      <div className="container">

        <h1>Reflex Advisor</h1>

        <div className="card">
          <h2>1. Introduction</h2>
          <p>
            Hello, my name is [Your Name] from Reflex Advisor. Could you connect
            me with the owner or manager, or would that be you?
          </p>
        </div>

        <div className="card">
          <h2>2. Reason for the Call</h2>
          <p>
            We help service companies get more business from other companies,
            mostly commercial.
          </p>
          <p>
            We have a big list of businesses and can give you contracts. We also
            do lead generation, manage leads, and set appointments.
          </p>
          <div className="qbox">
            <div className="qtitle">Qualifying Question 1</div>
            <p>
              I just want to ask you a few questions, just want to understand
              your position better. So can you please let me know how you are
              generating leads right now—by Google Ads, Facebook Ads, or word of
              mouth?
            </p>
          </div>
        </div>

        <div className="card">
          <h2>3. Qualifying Question 2</h2>
          <div className="qbox">
            <div className="qtitle">Qualifying Question 2</div>
            <p>
              What time would work best for you in the next few days so we can
              set up a call with our Vice President of Sales. He'll brief you on
              how this can help scale your company.
            </p>
            <p>
              Are you available Monday, Tuesday, or Wednesday—morning or
              afternoon?
            </p>
          </div>
        </div>

        <div className="card">
          <h2>4. Qualifying Question 3</h2>
          <div className="qbox">
            <div className="qtitle">Qualifying Question 3</div>
            <p>
              Please also let me know how much you can spend to get a predictable
              sales system that can increase your sales by 10x this month. Any
              rough idea or budget range you would consider if we take care of
              all your sales problems?
            </p>
          </div>
        </div>

        <div className="card">
          <h2>5. If Not Interested (Fallback Question)</h2>
          <p>
            Quick question—what's one task in your business that you hate doing
            every day and would love to hand off to someone else?
          </p>
          <p>
            For example, in my business, I don't enjoy handling data enrichment,
            managing tools, or tracking conversion metrics. I have a specialist
            take care of these tasks so I can focus on growth.
          </p>
        </div>

        <div className="card">
          <h2>6. Objection Handling</h2>
          <div className="btn-col">
            <button
              className="objection-btn"
              onClick={() => setSalesModalOpen(true)}
            >
              💬 "How can you increase sales by 10x?"
            </button>
            <button
              className="pricing-btn"
              onClick={() => setPricingModalOpen(true)}
            >
              💰 "What's the pricing?"
            </button>
          </div>
        </div>

      </div>

      {/* Sales 10x Modal */}
      {salesModalOpen && (
        <div
          className="modal-overlay"
          onClick={(e) => { if (e.target === e.currentTarget) setSalesModalOpen(false); }}
        >
          <div className="modal">
            <button className="modal-close" onClick={() => setSalesModalOpen(false)}>×</button>

            <div className="modal-badge">Objection Response</div>
            <h3>"How can you increase our sales by 10x?"</h3>
            <p className="tagline">
              Great question. We don't just book calls.{" "}
              <strong>We become your VP of Sales and fix everything.</strong>
            </p>

            <div className="modal-divider">Here's what we handle</div>

            <ul className="modal-list">
              <li>Full sales audit</li>
              <li>Fix sales system</li>
              <li>Define your ICP</li>
              <li>Sharpen your offer</li>
              <li>Build email marketing</li>
              <li>Set up automation</li>
              <li>Add lead sources</li>
              <li>Improve outreach</li>
              <li>Tighten follow-ups</li>
              <li>Boost booked jobs</li>
            </ul>

            <div className="modal-footer">
              <strong>Sales. Marketing. Operations.</strong> All done for you.<br /><br />
              Our VP of Sales will walk you through exactly how this works for your business.<br /><br />
              My job is simple — I just book the call.{" "}
              <strong>When are you free next week?</strong>
            </div>
          </div>
        </div>
      )}

      {/* Pricing Modal */}
      {pricingModalOpen && (
        <div
          className="modal-overlay"
          onClick={(e) => { if (e.target === e.currentTarget) setPricingModalOpen(false); }}
        >
          <div className="modal">
            <button className="modal-close" onClick={() => setPricingModalOpen(false)}>×</button>

            <div className="modal-badge-blue">Pricing Objection</div>
            <h3>"What's the pricing?"</h3>
            <p className="tagline">
              I'm not really the right person to go into full pricing details — but here's what I can tell you:
            </p>

            <div className="pricing-highlight">
              <div className="price">$225 / week</div>
              <div className="per">Starting package — very cost-effective</div>
            </div>

            <div className="pricing-footer">
              What I can do is connect you with our <strong>Vice President of Sales</strong>. He'll give you complete information and walk you through everything properly.<br /><br />
              Don't worry about it — <strong>he'll handle all the details on the call.</strong>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}